import React from 'react';
import { Card, Box, Typography, Divider, Grid, Stack } from '@mui/material';

export default function TransactionStatsData({ totalAmount = 2, numberOfTransactions = 1 }) {
  return (
    <>
      <Stack
        direction="column"
        spacing={2}
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <Typography sx={{ fontSize: '25px', fontWeight: 700, fontFamily: 'Montserrat' }}>
          Rs. {totalAmount}
        </Typography>
        <Typography sx={{ fontSize: '14px', fontWeight: 700 }}>Total Amount</Typography>
        <Divider sx={{ my: 1.5, width: '100%' }} />
        <Typography sx={{ fontSize: '25px', fontWeight: 700, fontFamily: 'Montserrat' }}>
          {numberOfTransactions}
        </Typography>
        <Typography sx={{ fontSize: '14px', fontWeight: 700 }}>
          Total No. of Transactions
        </Typography>
      </Stack>
    </>
  );
}
